import React, { useState, useRef, useEffect } from "react";
import { X, Search, Link2 } from "lucide-react";
import Avatar from "./Avatar";

export default function CollaboratorAssign({ allPeople, collaboratorIds, excludeId, onAssign }) {
  const [search, setSearch] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setShowDropdown(false);
        setSearch("");
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const ids = collaboratorIds || [];
  const selected = (allPeople || []).filter((p) => ids.includes(p.id));
  const available = (allPeople || [])
    .filter((p) => !ids.includes(p.id) && p.id !== excludeId)
    .filter((p) => (p.name || "").toLowerCase().includes(search.toLowerCase()))
    .slice(0, 8);

  const handleAdd = (person) => {
    onAssign([...ids, person.id]);
    setSearch("");
  };

  const handleRemove = (personId) => {
    onAssign(ids.filter((id) => id !== personId));
  };

  return (
    <div ref={containerRef} className="relative">
      <label className="text-sm font-medium text-gray-700">Functional Leaders</label>
      <p className="text-xs text-gray-400 mb-2">
        Assign functional leaders to this person across the organization.
      </p>
      {selected.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mb-2">
          {selected.map((p) => (
            <div
              key={p.id}
              className="flex items-center gap-1.5 bg-accent border border-border rounded-full pl-0.5 pr-2 py-0.5"
            >
              <Avatar name={p.name} photoUrl={p.photo_url} size="xs" />
              <span className="text-xs font-medium text-foreground max-w-[100px] truncate">
                {p.name}
              </span>
              <button
                type="button"
                onClick={() => handleRemove(p.id)}
                className="text-gray-400 hover:text-red-500 transition-colors"
              >
                <X className="w-3 h-3" />
              </button>
            </div>
          ))}
        </div>
      )}
      <button
        type="button"
        onClick={() => setShowDropdown(!showDropdown)}
        className="flex items-center gap-1.5 px-3 py-2 text-xs border border-dashed border-gray-300 rounded-lg text-gray-500 hover:text-blue-600 hover:border-blue-400 transition-colors w-full bg-card"
      >
        <Link2 className="w-3.5 h-3.5" />
        {selected.length > 0 ? "Add another functional leader" : "Assign functional leaders"}
      </button>
      {showDropdown && (
        <div className="absolute z-50 mt-1 w-full bg-card border border-border rounded-lg shadow-lg overflow-hidden">
          <div className="relative">
            <Search className="w-3.5 h-3.5 absolute left-2 top-1/2 -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search people..."
              autoFocus
              className="w-full pl-7 pr-2 py-2 text-xs border-b border-border focus:outline-none bg-transparent text-foreground"
            />
          </div>
          <div className="max-h-40 overflow-y-auto">
            {available.length === 0 ? (
              <p className="text-xs text-gray-400 text-center py-3">No people found</p>
            ) : (
              available.map((p) => (
                <button
                  key={p.id}
                  type="button"
                  onClick={() => handleAdd(p)}
                  className="flex items-center gap-2 w-full px-2 py-1.5 hover:bg-accent transition-colors text-left"
                >
                  <Avatar name={p.name} photoUrl={p.photo_url} size="xs" />
                  <div className="min-w-0">
                    <p className="text-xs font-medium text-foreground truncate">{p.name}</p>
                    <p className="text-[10px] text-gray-400 truncate">
                      {p.function_area || p.role_level}
                    </p>
                  </div>
                </button>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}